import React from "react";
import { Box } from "@mui/material";
import LanguageToggleButton from "./LanguageToggleButton";
import ThemeToggleButton from "./ThemeToggleButton";

/** Fixed top-right language + theme toggles (equal size, auth pages). */
export default function AuthPageToggleBar({ showOnlyOnLogin = true, sx }) {
  const isLoggedIn = localStorage.getItem("realmJwt") || localStorage.getItem("supabaseToken");
  if (showOnlyOnLogin && isLoggedIn) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "fixed",
        top: "max(12px, env(safe-area-inset-top, 0px))",
        right: "max(12px, env(safe-area-inset-right, 0px))",
        zIndex: 1100,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 1,
        pointerEvents: "none",
        "& > *": { pointerEvents: "auto" },
        ...sx,
      }}
    >
      <LanguageToggleButton showOnlyOnLogin={showOnlyOnLogin} embedded />
      <ThemeToggleButton showOnlyOnLogin={showOnlyOnLogin} embedded />
    </Box>
  );
}
